'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _immutable = require('immutable');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

var _attachmentTypes = require('../constants/attachmentTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuickReplyAttachment = function (_Record) {
  _inherits(QuickReplyAttachment, _Record);

  function QuickReplyAttachment() {
    var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, QuickReplyAttachment);

    var quickReplies = (0, _immutable.fromJS)((0, _get2.default)('quickReplies', properties));

    return _possibleConstructorReturn(this, (QuickReplyAttachment.__proto__ || Object.getPrototypeOf(QuickReplyAttachment)).call(this, _extends({}, properties, {
      quickReplies: (0, _immutable.OrderedSet)(quickReplies)
    })));
  }

  return QuickReplyAttachment;
}((0, _immutable.Record)((_Record2 = {}, _defineProperty(_Record2, _messageTypes.MESSAGE_TYPE_ID, _attachmentTypes.QUICK_REPLIES), _defineProperty(_Record2, 'quickReplies', (0, _immutable.OrderedSet)()), _defineProperty(_Record2, 'allowMultiSelect', false), _defineProperty(_Record2, 'allowUserInput', false), _Record2)));

exports.default = QuickReplyAttachment;
module.exports = exports['default'];